<template>
  <div>
    <!-- 配货商品信息录入表单 -->
    <el-dialog :title="$t('message.assignmentCommodityInformationEntry')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1280px" center>
      <div class="content">

        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
              </el-checkbox>
            </li>
            <!-- 订单号 -->
            <li>{{ $t('message.orderNumber') }}</li>
            <!-- NO -->
            <li class="flex05">NO</li>
            <!--图片  -->
            <li>{{ $t('message.pic') }}</li>
            <!-- 业务编辑属性 -->
            <li class="flex2">{{ $t('message.businessEditAttributes') }}</li>
            <!-- 商品数量 -->
            <li>{{ $t('message.numberOfProducts') }}</li>
            <!-- 业务商品备注 -->
            <li>{{ $t('message.salesmanCommodityRemarks') }}</li>
            <!-- 尺寸 -->
            <li class="flex15">{{ $t('message.size') }}</li>
            <!-- 重量 -->
            <li class="flex15">{{ $t('message.weight') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 选择 -->
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="handleRowCheckChange"></el-checkbox>
            </li>
            <!-- 订单号 -->
            <li>{{ item.order_sn }}</li>
            <!-- NO -->
            <li class="flex05">{{ item.sorting }}</li>
            <!--图片  -->
            <li>
              <img :src="item.pic" alt="" style="width: 100px; height: 100px;">
            </li>
            <!-- 业务编辑属性 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 商品数量 -->
            <li>
              <div class="template">
                <div class="template attribute">
                  <!-- 可入库 -->
                  <p class="row">{{ $t("message.canBePutIntoStorage") }}:{{ item.possible_num_total }}</p>
                  <!-- 已到货 -->
                  <p>{{ $t("message.itHasArrived") }}:{{ item.storage_num_total }}</p>
                  <!-- 已出货 -->
                  <p>{{ $t("message.shipped") }}:{{ item.delivery_total }}</p>
                </div>
              </div>
            </li>
            <!-- 业务商品备注 -->
            <li>{{ item.y_remark }}</li>
            <!-- 尺寸 -->
            <li class="flex15">
              <div class="template">
                <div class="row">
                  <el-input v-model="item.length" placeholder="长" size="small" type="number"
                    @input="syncCheckedValue(item, 'length')"><template slot="append">cm</template></el-input>
                </div>
                <div class="row">
                  <el-input v-model="item.width" placeholder="宽" size="small" type="number"
                    @input="syncCheckedValue(item, 'width')"><template slot="append">cm</template></el-input>
                </div>
                <div class="row">
                  <el-input v-model="item.height" placeholder="高" size="small" type="number"
                    @input="syncCheckedValue(item, 'height')"><template slot="append">cm</template></el-input>
                </div>
              </div>
            </li>
            <!-- 重量 -->
            <li class="flex15">
              <el-input v-model="item.weight_kg" placeholder="重量" size="small" type="number"
                @input="syncCheckedValue(item, 'weight_kg')"><template slot="append">kg</template></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {

      dialogVisible: false,
      datas: {
        order_sn: '',
        order_detail_ids: [],
      },
      selectedList: [],
      tableData: [],// 配货商品信息录入表单数据
      checkAll: false,
      isIndeterminate: false,
    };
  },
  methods: {
    // 配货商品信息录入表单
    deliveryPreview() {
      this.$api.spotCheckApi.deliveryPreview(this.datas).then(res => {
        res.data.list.forEach(item => {
          this.selectedList.forEach(selectedItem => {
            if (selectedItem.id == item.id) {
              item.detail_y = selectedItem.detail_y
              item.y_remark = selectedItem.y_remark
              item.possible_num_total = selectedItem.possible_num_total
              item.storage_num_total = selectedItem.storage_num_total
              item.delivery_total = selectedItem.delivery_total

            }
          })
          item.weight_kg = this.gramToKilogram(item.weight)
          this.$set(item, 'checked', false)
        })
        this.tableData = res.data.list
        this.handleRowCheckChange()
        this.dialogVisible = true
      })
    },
    // 全选或取消全选当前弹框列表
    handleCheckAllChange(value) {
      this.tableData.forEach(item => {
        this.$set(item, 'checked', value)
      })
      this.isIndeterminate = false
    },
    // 根据行勾选状态更新全选按钮状态
    handleRowCheckChange() {
      const checkedCount = this.tableData.filter(item => item.checked).length
      this.checkAll = this.tableData.length > 0 && checkedCount === this.tableData.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length
    },
    // 修改勾选行的尺寸或重量时，同步到其他已勾选行
    syncCheckedValue(currentItem, field) {
      if (!currentItem.checked) return
      this.tableData.forEach(item => {
        if (item.checked && item.id !== currentItem.id) {
          this.$set(item, field, currentItem[field])
        }
      })
    },
    // 保存前将千克转换回克
    kilogramToGram(value) {
      if (value === '' || value === null || value === undefined) return ''
      return Number(value) * 1000
    },
    // 接口返回的克转换成千克展示
    gramToKilogram(value) {
      if (value === '' || value === null || value === undefined) return ''
      return Number(value) / 1000
    },
    // 保存
    save() {
      let datas = {
        task_sn: '',
        list: []
      }

      this.tableData.forEach(item => {
        datas.list.push({
          order_detail_id: item.id,
          length: item.length,
          width: item.width,
          height: item.height,
          weight: this.kilogramToGram(item.weight_kg),
        })
      })
      this.$api.spotCheckApi.deliverySave(datas).then(res => {
        this.$message({
          message: res.msg,
          type: 'success'
        })
        this.dialogVisible = false
        this.$parent.refresh()
      })
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;



  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow-y: auto;

    ol {
      display: flex;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 99;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 12px 12px;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex2 {
      flex: 2;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }


  }

  .table {
    .row {
      margin-bottom: 5px;
    }
  }



}
</style>
